<template lang="html">
  <section class="social-authentication">
    <div v-if="isLoading"><Loader /></div>
    <div class="social-authentication text-center mt-4">
      <h5>
        <span>{{ $t('socialSignIn') }}</span>
      </h5>
      <div class="authentication-icon">
        <ul
          class="d-flex justify-content-center mb-4 list-unstyled"
          aria-label="authentication icon"
        >
          <li>
            <a @click="googleSignIn()">
              <i class="icon-google" aria-hidden="true"></i>
            </a>
          </li>
          <!-- <li>
            <a >
              <i class="icon-apple" aria-hidden="true"></i>
            </a>
          </li> -->
          <li>
            <a @click="twitterSignIn()" id="twitter">
              <svg
                width="23"
                height="24"
                viewBox="0 0 23 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M9.88487 14.4046C9.72019 14.5957 9.57022 14.7678 9.42025 14.9413C8.33222 16.2072 7.2442 17.4746 6.15617 18.7391C5.18283 19.8712 4.20802 21.0019 3.2332 22.134C2.84651 22.5824 2.45982 23.0323 2.07607 23.4823C2.03196 23.5337 1.98785 23.5617 1.91581 23.5617C1.30416 23.5587 0.691044 23.5602 0.0793965 23.5602C0.0646935 23.5602 0.0499904 23.5572 0.0102921 23.5528C0.232308 23.2661 0.470498 23.0118 0.693985 22.7456C0.920412 22.4766 1.15419 22.2119 1.38356 21.9443C1.61293 21.6767 1.84376 21.4106 2.07313 21.143C2.30544 20.8725 2.53775 20.6005 2.77153 20.3299C3.00089 20.0623 3.23173 19.7962 3.46257 19.5286C3.69341 19.261 3.92278 18.9949 4.15361 18.7273C4.38298 18.4597 4.61235 18.1921 4.84172 17.9245C5.07109 17.6569 5.30045 17.3893 5.53129 17.1232C5.76066 16.8556 5.99297 16.5895 6.22234 16.3233C6.45611 16.0528 6.68695 15.7808 6.92073 15.5103C7.1501 15.2427 7.37947 14.9751 7.6103 14.7089C7.83967 14.4413 8.07051 14.1752 8.30135 13.9076C8.53072 13.6415 8.75861 13.3739 8.99092 13.1034C5.99297 8.73656 3.00237 4.38298 0 0.0117625C0.0676341 0.00735153 0.108803 0.00294061 0.151442 0.00294061C2.33632 0.00294061 4.52119 0.00294061 6.70607 0C6.81634 0 6.87221 0.0470498 6.92955 0.129387C7.31771 0.699866 7.71029 1.26887 8.10139 1.83788C8.86889 2.95532 9.63639 4.07422 10.4054 5.19165C11.1758 6.3135 11.9477 7.43534 12.7196 8.55571C12.7431 8.591 12.7696 8.62335 12.8034 8.66746C12.8608 8.60129 12.9078 8.54689 12.9549 8.49102C14.0914 7.17068 15.228 5.84888 16.3645 4.52854C17.2643 3.48169 18.1656 2.43483 19.0655 1.38797C19.436 0.957169 19.8065 0.52784 20.1741 0.0955699C20.2299 0.0308764 20.2873 0.00147031 20.3755 0.00147031C20.9636 0.00441092 21.5517 0.00294061 22.1384 0.00294061C22.1678 0.00294061 22.1957 0.00735153 22.2237 0.00882184C22.2266 0.0176437 22.2296 0.0220546 22.231 0.0264655C22.2325 0.0308764 22.234 0.0367577 22.2325 0.0396983C22.2281 0.0485201 22.2222 0.0573419 22.2178 0.0646935C22.2119 0.072045 22.206 0.0808668 22.2002 0.0882184C22.1913 0.0999808 22.181 0.110273 22.1707 0.120565C19.361 3.38759 16.5512 6.65314 13.743 9.92016C13.7371 9.92751 13.7312 9.93633 13.7253 9.94368C13.7224 9.94809 13.7209 9.9525 13.718 9.95691C13.7165 9.96132 13.715 9.96574 13.7047 9.9922C16.7997 14.4972 19.9006 19.0125 23 23.5249C22.9956 23.5367 22.9941 23.5411 22.9912 23.5455C22.9882 23.5484 22.9853 23.5543 22.9824 23.5543C20.7196 23.5543 18.4568 23.5543 16.1748 23.5543C14.0841 20.5152 11.9889 17.4672 9.88487 14.4046ZM2.75094 1.53647C2.77741 1.57911 2.79358 1.60852 2.8127 1.63498C3.9463 3.25673 5.07991 4.87701 6.21351 6.49875C7.27066 8.0117 8.32781 9.52464 9.38496 11.0376C10.473 12.5946 11.561 14.1517 12.6505 15.7088C14.1179 17.8069 15.5838 19.9065 17.0497 22.0061C17.1026 22.0825 17.1585 22.1149 17.2526 22.1149C18.2083 22.1119 19.1625 22.1119 20.1182 22.1119C20.155 22.1119 20.1917 22.1046 20.2417 22.0987C20.2182 22.0546 20.2049 22.0237 20.1873 21.9973C20.0109 21.7444 19.833 21.4929 19.6565 21.24C18.5494 19.6551 17.4422 18.0686 16.3351 16.4836C15.1015 14.7178 13.8665 12.9534 12.6314 11.1876C11.5831 9.68932 10.5362 8.19255 9.49083 6.69577C8.31605 5.01374 7.13981 3.33318 5.96797 1.64968C5.90475 1.55852 5.84006 1.52324 5.72831 1.52471C4.78291 1.52912 3.8375 1.52618 2.89209 1.52618C2.85092 1.52618 2.80828 1.53206 2.75094 1.53647Z"
                  fill="black"
                />
              </svg>
            </a>
          </li>

          <!-- <li>
            <a @click="SignOut()">
              <i class="icon-facebook" aria-hidden="true"></i>
            </a>
          </li> -->
        </ul>
      </div>

      <div
        class="success-submit-box modal fade mt-3 d-none"
        :class="{ addsuccess: showEmail, show: showEmail }"
        id="exampleModal"
        tabindex="-1"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div class="modal-dialog modal-dialog-centered">
          <div class="modal-content border-0 p-3">
            <div class="modal-body">
              <h2 class="mb-3">Enter Email to continue</h2>
              <p>
                Since your account doesn't have an associated email ID, we kindly request you to
                provide your email for communication purposes and order tracking.
              </p>
              <input type="text" id="ip2" v-model="email" />
            </div>
            <div class="text-center">
              <button
                class="btn btn-primary btn-lg submit-btn mb-3"
                data-dismiss="modal"
                @click="sendOtpPopup()"
              >
                Send OTP
              </button>
            </div>
          </div>
        </div>
      </div>

      <div
        class="success-submit-box modal fade mt-3 d-none"
        :class="{ addsuccess: showOtp, show: showOtp }"
        id="exampleModal"
        tabindex="-1"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div class="modal-dialog modal-dialog-centered">
          <div class="modal-content border-0 p-3">
            <div class="modal-body">
              <h2 class="mb-3">Verify OTP</h2>
              <p>Code has been send to {{ email }}</p>
              <input type="text" id="ip2" v-model="otpNumber" />
            </div>
            <div class="text-center">
              <button
                class="btn btn-primary btn-lg submit-btn mb-3"
                data-dismiss="modal"
                @click="verifyOtpPopup()"
              >
                Verify OTP
              </button>
            </div>
          </div>
        </div>
      </div>

      <div
        class="success-submit-box modal fade mt-3 d-none"
        :class="{ addsuccess: showError, show: showError }"
        id="exampleModal"
        tabindex="-1"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div class="modal-dialog modal-dialog-centered">
          <div class="modal-content border-0 p-3">
            <div class="modal-body">
              <h2 class="mb-3">ERROR</h2>
              <p>Something went wrong. Please try again.</p>
            </div>
            <div class="text-center">
              <button
                class="btn btn-primary btn-lg submit-btn mb-3"
                data-dismiss="modal"
                @click="showErrorPopup()"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script lang="js">

// eslint-disable-next-line import/no-extraneous-dependencies
import {
  getAuth, signInWithPopup, GoogleAuthProvider, TwitterAuthProvider, signOut,
} from 'firebase/auth';
import { useCookies } from 'vue3-cookies';
import { useRouter } from 'vue-router';
import { onMounted, ref } from 'vue';
import StoryphoneService from '@/services/StoryphoneService';
import CLayerService from '@/services/CLayerService';
import Loader from '@/components/commons/Loader.vue';
import firebaseConfig from '../../mixins/firebaseConfig';

const { cookies } = useCookies({ secure: true });

// eslint-disable-next-line no-unused-expressions
firebaseConfig;
const cLayerService = new CLayerService();
const storyphoneService = new StoryphoneService();
const provider = new GoogleAuthProvider();
const providerTwitter = new TwitterAuthProvider();
const auth = getAuth();

export default {
  name: 'social-authentication',
  props: [],
  components: {
    Loader,
  },
  setup() {
    const isLoading = ref(false);
    const showEmail = ref(false);
    const showOtp = ref(false);
    const email = ref('');
    const otpNumber = ref('');
    const otpToken = ref('');
    const showError = ref(false);

    onMounted(() => {
      const twitter = document.getElementById('twitter');

      twitter.addEventListener('mouseover', () => {
        twitter.style.setProperty('fill', '#fff');
      });

      twitter.addEventListener('mouseout', () => {
        twitter.style.setProperty('fill', '#000');
      });
    });

    const market = localStorage.getItem('marketId');
    const router = useRouter();
    const googleSignIn = () => {
      isLoading.value = true;
      provider.setCustomParameters({
        prompt: 'select_account',
      });
      signInWithPopup(auth, provider)
        .then((result) => {
          // const token = result.credential.accessToken;
          // const { user } = result;
          const credential = GoogleAuthProvider.credentialFromResult(result);
          const token = credential.accessToken;
          const data = {
            access_token: token,
            scope: `market:id:${market}`,
          };
          storyphoneService.googleLogin(data)
            .then((response) => {
              cookies.set('storyPhoneUserAuthCookie', {
                access_token: response.data.accessToken,
              });
              cookies.set('storyPhoneUserRefreshCookie', {
                refresh_token: response.data.refreshToken,
              });

              cookies.set('clUserAuthCookie', {
                access_token: response.data.commercelayerAccessToken,
              });
              cookies.set('clUserAuthRefreshCookie', {
                refresh_token: response.data.commercelayerRefreshToken,
              });
              cookies.set('clUserOwnerId', {
                owner_id: response.data.commercelayerUserId,
              });
              const id = cookies.get('clUserOwnerId');
              cookies.remove('clAuthCookie');
              cookies.remove('orderIdCookie');
              cLayerService.checkPendingOrder(id.owner_id)
                .then((order) => {
                  if (order.length > 0) {
                    cookies.set('orderIdCookie', {
                      orderId: order[0].id,
                    });
                  }
                  const { orderId } = cookies.get('orderIdCookie');
                });
              isLoading.value = false;
              router.push('/my-account');
            })
            .catch((error) => {
              console.log(error);
              showError.value = true;
              isLoading.value = false;
            });
        })
        .catch((err) => {
          isLoading.value = false;
          showError.value = true;
          console.log(err.code); // This will give you all the information needed to further debug any errors
        });
    };

    const twitterSignIn = () => {
      isLoading.value = true;
      providerTwitter.setCustomParameters({
        prompt: 'select_account',
      });
      signInWithPopup(auth, providerTwitter)
        .then((result) => {
          const credential = TwitterAuthProvider.credentialFromResult(result);

          const token = credential.accessToken;

          const data = {
            oauth_token: token,
            oauth_token_secret: credential.secret,
            scope: `market:id:${market}`,
          };
          storyphoneService.twitterLogin(data)
            .then((response) => {
              if (response.data.email_required) {
                otpToken.value = response.data.accessToken;
                showEmail.value = true;
                isLoading.value = false;
              } else {
                cookies.set('storyPhoneUserAuthCookie', {
                  access_token: response.data.accessToken,
                });
                cookies.set('storyPhoneUserRefreshCookie', {
                  refresh_token: response.data.refreshToken,
                });

                cookies.set('clUserAuthCookie', {
                  access_token: response.data.commercelayerAccessToken,
                });
                cookies.set('clUserAuthRefreshCookie', {
                  refresh_token: response.data.commercelayerRefreshToken,
                });
                cookies.set('clUserOwnerId', {
                  owner_id: response.data.commercelayerUserId,
                });
                const id = cookies.get('clUserOwnerId');
                cookies.remove('clAuthCookie');
                cookies.remove('orderIdCookie');
                cLayerService.checkPendingOrder(id.owner_id)
                  .then((order) => {
                    if (order.length > 0) {
                      cookies.set('orderIdCookie', {
                        orderId: order[0].id,
                      });
                    }
                  });
                isLoading.value = false;
                router.push('/my-account');
              }
            })
            .catch((error) => {
              console.log(error);
              isLoading.value = false;
              showError.value = true;
            });
        })
        .catch((error) => {
          console.log(error.message);
          isLoading.value = false;
          showError.value = true;
        });
    };

    const sendOtpPopup = () => {
      const data = {
        email: email.value,
        scope: `market:id:${market}`,
      };
      storyphoneService.sendOTP(data, otpToken.value)
        .then((response) => {
          showEmail.value = false;
          showOtp.value = true;
        })
        .catch((error) => {
          console.log(error);
          showError.value = true;
        });
    };

    const verifyOtpPopup = () => {
      const data = {
        otp: otpNumber.value,
        scope: `market:id:${market}`,
      };
      storyphoneService.verifyOTP(data, otpToken.value)
        .then((response) => {
          isLoading.value = true;
          showOtp.value = false;
          cookies.set('storyPhoneUserAuthCookie', {
            access_token: response.data.accessToken,
          });
          cookies.set('storyPhoneUserRefreshCookie', {
            refresh_token: response.data.refreshToken,
          });

          cookies.set('clUserAuthCookie', {
            access_token: response.data.commercelayerAccessToken,
          });
          cookies.set('clUserAuthRefreshCookie', {
            refresh_token: response.data.commercelayerRefreshToken,
          });
          cookies.set('clUserOwnerId', {
            owner_id: response.data.commercelayerUserId,
          });
          const id = cookies.get('clUserOwnerId');

          cookies.remove('clAuthCookie');
          cookies.remove('orderIdCookie');
          cLayerService.checkPendingOrder(id.owner_id)
            .then((order) => {
              if (order.length > 0) {
                cookies.set('orderIdCookie', {
                  orderId: order[0].id,
                });
              }
            });
          isLoading.value = false;
          router.push('/my-account');
        })
        .catch((error) => {
          console.log(error);
          showError.value = true;
          isLoading.value = false;
        });
    };

    const showErrorPopup = () => {
      showError.value = false;
    };

    const SignOut = () => {
      signOut(auth).then((response) => {
      }).catch((error) => {
        console.log(error);
      });
    };

    return {
      googleSignIn,
      twitterSignIn,
      SignOut,
      isLoading,
      showEmail,
      email,
      otpNumber,
      sendOtpPopup,
      verifyOtpPopup,
      showOtp,
      showErrorPopup,
      showError,
    };
  },
};
</script>

<style scoped lang="scss"></style>
